<template>
  <div class="site-content">
    <div class="site-content__wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.site-content {
  padding-top: 16px;
  min-height: calc(100% - 141px);
}
</style>
